@if (!downloading) {
    <mat-icon (click)="downloadConfirmation()" class="material-symbols-outlined">print</mat-icon>
}
@if (downloading) {
    <mat-spinner diameter="16" />
}
